var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{staticClass:"pa-0",attrs:{"disabled":!_vm.gradeId,"value":_vm.value,"loading":_vm.subject.fetching,"items":_vm.subjectItems,"outlined":"","dense":"","label":_vm.label || 'Select subject'},on:{"change":_vm.setSubject}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }